var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leadership_team"},_vm._l((JSON.parse(_vm.team)),function(team_member,index){return _c('team-listing-item',{key:(index),attrs:{"staff_name":team_member.staff_name,"staff_role":team_member.staff_role,"linked_in":team_member.linked_in,"email":team_member.email,"profile_picture":team_member.profile_picture}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib?{}!./scripts/vue/TeamListing.vue?vue&type=template&id=1802c40d&scoped=true&
// module id = 383
// module chunks = 0